export class Configuration implements ConfigurationInterface {
    _id: string = "";
    _property_id: string = "";
    options: ConfigurationOptionsInterface = {
        globalDatabaseSearch: false,
        urlContainsActive: false,
        deadbolt: "off",
        facebook: "off",
        timezoneFiltering: false,
        ispFiltering: false,
        locationFiltering: false,
        userAgentFiltering: false,
        browserHeadersFiltering: false,
        dayParting: false,
        stickyFiltering: false,
    };
    configuration: ConfigurationOptionSettingsInterface = {
        urlContains: "",
        allowedTimezones: [],
        blockedTimezones: [],
        blockedPostalCodes: [],
        blockedCities: [],
        allowedISPs: [],
        blockedISPs: [],
        allowedCountries: [],
        blockedCountries: [],
        allowedUserAgents: [],
        blockedUserAgents: [],
        allowedBrowerHeaders: [],
        blockedBrowerHeaders: [],
    };

    constructor(raw: ConfigurationInterface) {
        Object.assign(this, raw);
        console.log(raw);
    }
}

export interface ConfigurationOptionSettingsInterface {
    urlContains: string;
    allowedTimezones: Array<string>;
    blockedTimezones: Array<string>;
    blockedPostalCodes: Array<string>;
    blockedCities: Array<string>;
    allowedISPs: Array<string>;
    blockedISPs: Array<string>;
    allowedCountries: Array<string>;
    blockedCountries: Array<string>;
    allowedUserAgents: Array<string>;
    blockedUserAgents: Array<string>;
    allowedBrowerHeaders: Array<string>;
    blockedBrowerHeaders: Array<string>;
    //Todo dayparting
}

export interface ConfigurationOptionsInterface {
    globalDatabaseSearch?: boolean;
    urlContainsActive?: boolean;
    deadbolt: string;
    facebook: string;
    timezoneFiltering?: boolean;
    ispFiltering?: boolean;
    locationFiltering?: boolean;
    userAgentFiltering?: boolean;
    browserHeadersFiltering?: boolean;
    dayParting?: boolean;
    stickyFiltering?: boolean;
}

export interface ConfigurationInterface {
    _id: string;
    _property_id: string;
    options: ConfigurationOptionsInterface;
    configuration: ConfigurationOptionSettingsInterface;
}